import * as moment from 'moment';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMM YYYY',
  },
  format: {
    short: 'dd/MM/yyyy',
    long: 'dd MMM yyyy'
  }
};

interface DDMMYYYY {
  day: string,
  month: string,
  year: string
}

export class DateUtils {

  static convertDate(value: Date | moment.Moment): Date {
    if (moment.isMoment(value)) {
      return value.toDate();
    }
    return value;
  }

  static areEqual(value1: Date, value2: Date){
    return moment(value1).isSame(value2);
  }

  static today(): Date {
    return new Date();
  }

  static addDays(value: Date | moment.Moment, days: number = 1): Date {
    return moment(value).add(days, 'days').toDate();
  }

  static addMonth(value: Date | moment.Moment, months: number = 1): Date {
    return moment(value).add(months, 'months').toDate();
  }

  static addYear(value: Date | moment.Moment, years: number = 1): Date {
    return moment(value).add(years, 'years').subtract(1, 'days').toDate();
  }

  static age(value: Date | moment.Moment | string | null): number {
    if (value == null) return null;

    var ageValue: moment.Moment;

    if (moment.isMoment(value)) {
      ageValue = value;
    } else {
      ageValue = moment(value);
    }

    return moment().diff(ageValue, 'years');
  }

  static isDate(value: any): boolean {
    if (moment.isMoment(value)) {
      return value.isValid();
    } else {
      return Object.prototype.toString.call(value) === '[object Date]'
        && value.toString() !== 'Invalid Date';
    }
  }

  static currentYear(): number {
    return new Date().getFullYear();
  }

  static currentCentury(): number {
    const year = new Date().getFullYear();
    const strYear = year.toString().substring(0, 2) + "00";
    return parseInt(strYear);
  }

  static parseDate(value: DDMMYYYY): Date | null {

    if (value != null
      && /[12][0-9]{3}/.test(value.year)
      && /[0-9]{1,2}/.test(value.month)
      && /[0-9]{1,2}/.test(value.day) ) {

      const day = Number(value.day);
      const month = Number(value.month) - 1;
      const year = Number(value.year);

      let result = new Date(year, month, day, 0, 0);

      if (this.isDate(result)
        && result.getFullYear() === year
        && result.getMonth() === month
        && result.getDate() === day) {
        return result;
      } else {
        return new Date('Invalid'); // Need to output invalid date
      }
    }

    return null;
  }

  static toString(date: Date): string {
    if (!date) return '';
    if(moment(date, MY_DATE_FORMATS.parse.dateInput, true).isValid()){
      return moment(date, MY_DATE_FORMATS.parse.dateInput, true ).format(MY_DATE_FORMATS.parse.dateInput);
    }
    date.toString();
  }


}
